import type { FunctionComponent } from 'react';

import PaidFeatureGate from '../Gates/PaidFeatureGate';
import PaidPill from '../Pill/PaidPill';
import type { FossaFeature } from '../../settings/billing/features/consts';

import SubnavDropdownItem, { type DropdownItemProps } from './SubnavDropdownItem';

import styles from './Subnav.module.less';

type Props = DropdownItemProps & {
  isRestricted: boolean;
  modalFocusFeature?: FossaFeature;
};

export type SubnavDropdownPaidFeatureItemComponent = FunctionComponent<Props>;

/**
 * This is a Dropdown item which displays the "paid" feature badge
 */
const SubnavDropdownPaidFeatureItem: SubnavDropdownPaidFeatureItemComponent = ({
  to,
  navKey,
  children,
  isRestricted,
  modalFocusFeature,
}) => {
  return (
    <PaidFeatureGate isRestricted={isRestricted} modalFocusFeature={modalFocusFeature} hidePill>
      <SubnavDropdownItem to={to} navKey={navKey}>
        {children}
        {isRestricted && (
          <span className={styles.paidSpacing}>
            <PaidPill />
          </span>
        )}
      </SubnavDropdownItem>
    </PaidFeatureGate>
  );
};

export default SubnavDropdownPaidFeatureItem;
